import * as React from 'react';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { find, flow, forEach, get, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { IAuthState } from '../../../../services/auth/models';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { actions as modalActions } from '../../../../services/modal/reducer';
import { IQuoteActions } from '../../../../services/quote/models';
import { IBrandingActions, IBrandingState } from '../../../../services/branding/models';
import { destroy, reset } from 'redux-form';
import Loading from '../../../../components/Loading';
import { withJob } from 'react-jobs';
import { IPolicy, ITraveller } from '../../../../data/api/models';
import { IStore } from '../../../../redux/IStore';
import { mtaActions } from '../../../../services/mta/actions';
import { IMtaActions } from '../../../../services/mta/models';
import { OptInForRenewalModal } from '../../../../components/OptInForRenewalModal';
import { CardExpiredBanner, ICardExpired } from '../../../../components/CardExpiredBanner';
import { UpdateExpiredCard } from '../../../../components/UpdateExpiredCard';
import { paymentMethodActions } from '../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../services/paymentMethod/models';
import { Promise } from 'es6-promise';
import Heap from '../../../../helpers/Heap';
import { actions as headerActions } from '../../../../services/header/reducer';
import { IHeaderActions } from '../../../../services/header/models';
import { IModalActions } from '../../../../services/modal/model';
import { initUpsellModal } from '../../../../helpers/Marketing';
import PolicyCard from '../Components/PolicyCard';
import { SectionTitle } from '../Components/SectionTitle';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    branding: IBrandingActions,
    quote: IQuoteActions;
    mta: IMtaActions;
    header: IHeaderActions;
    modal: IModalActions;
    paymentMethod: IPaymentMethodActions;
    reset(formName: string);
    destroy(formName: string);
  };
  branding?: IBrandingState;
  quoteTable: any;
}

interface IAccountSummaryState {
  policyId: string;
  expiredPaymentId: string;
  travellers: ITraveller[];
  loading: boolean;
  policyNumber: string;
  showModal: boolean;
  showExpiredPolicies: boolean;
}

class AccountSummary extends React.Component<IAccountSummaryProps, IAccountSummaryState> {

  constructor(props: IAccountSummaryProps | Readonly<IAccountSummaryProps>) {
    super(props);

    const { auth, actions } = this.props;
    const mtaOptions = actions.mta.getCustomerMtaOptions();
    const claimsSSOEnabled = get(mtaOptions, 'other.enable_claims_sso', false)
    const sortedPolicyByDate = actions.auth.getLatestPolicy();

    if (claimsSSOEnabled) {
      actions.auth.getCustomerClaimsExternalUrl()
    }

    Heap.trackActivePolicyEvent(
      'EnterHomePage',
      sortedPolicyByDate,
      get(auth, 'customer.marketingOptions'),
      actions.paymentMethod.getPolicyPaymentMethod(get(sortedPolicyByDate, 'assignedPaymentMethods'))
    );

    this.state = {
      policyId: '',
      expiredPaymentId: '',
      travellers: null,
      loading: false,
      policyNumber: null,
      showModal: false,
      showExpiredPolicies: false,
    };

    initUpsellModal(
      auth,
      actions.quote,
      actions.modal,
      actions.mta,
      get(mtaOptions, 'upsell.campaign', null)
    );
  }

  private renderActivePoliciesCard = () => {
    const { auth } = this.props;
    const activePolicies = auth.customer.activePolicies;

    if (activePolicies.length < 1) {
      return (
        <>
          <h2><strong>Your Policies</strong></h2>
          <p>
            You currently don't have active policies.
          </p>
        </>
      )
    }

    return (
      <>
        <div>
          {activePolicies.map((policy: IPolicy, index) => {
            return (
              <PolicyCard policy={policy} key={index}/>
            );
          })}
        </div>
      </>
    );
  }

  private handleShowExpiredPolicies = () => {
    const { showExpiredPolicies } = this.state;
    this.setState({ showExpiredPolicies: !showExpiredPolicies })
  }
  private renderExpiredPoliciesCard = () => {
    const { auth } = this.props;
    const { showExpiredPolicies } = this.state;
    const expiredPolicies = auth.customer.expiredPolicies;

    if (expiredPolicies.length < 1) {
      return null;
    }
    return (
      <>
        <div className={'section-container'}>
          <div className={'status-indicator'}>
            <SectionTitle text={'Expired policies'}/>
          </div>
          <div className={'show-button'} onClick={this.handleShowExpiredPolicies}>{
            showExpiredPolicies ? <>HIDE <FaChevronUp/></> : <>SHOW <FaChevronDown/></>}
          </div>
        </div>
        {showExpiredPolicies && (
          <div>
            {expiredPolicies.map((policy: IPolicy, index) => {
              return (
                <PolicyCard policy={policy} key={index}/>
              );
            })}
          </div>
        )}
      </>
    );
  }

  private renderOptInRenewalModal = () => {
    const { auth, actions, branding } = this.props;
    const product = get(branding, 'channel.products[0]')
    return (
      <OptInForRenewalModal auth={auth} actions={actions.quote} product={product}/>
    )
  }

  private renderCardExpiryBanner = () => {
    const { auth } = this.props;
    const activePolicies = auth.customer.activePolicies;
    const paymentMethods = get(auth, 'customer.paymentMethods');
    const banner: ICardExpired[] = [];
    if (activePolicies.length < 1) {
      return null;
    }

    forEach(activePolicies, (policy) => {
      const assignedPaymentMethodId = get(policy, 'assignedPaymentMethods.id');
      if (assignedPaymentMethodId && !isEmpty(paymentMethods)) {
        const currentAssignedPaymentMethod = find(paymentMethods, ['id', assignedPaymentMethodId])
        const statuses = ['expired', 'disabled'];
        if (currentAssignedPaymentMethod) {
          if (statuses.includes(get(currentAssignedPaymentMethod, 'status', ''))) {
            banner.push({
              customerName: get(auth, 'customer.firstName'),
              policyId: get(policy, 'id'),
              policyNumber: get(policy, 'policyNumber'),
              expiredPaymentId: get(currentAssignedPaymentMethod, 'id'),
              travellers: get(policy, 'travellers', []),
              tripType: get(policy, 'metadata.scheme_type', ''),
              cardStatus: get(currentAssignedPaymentMethod, 'status'),
              hasRenewal: get(policy, 'hasRenewal'),
            })
          }
        }
      }
    })

    if (isEmpty(banner)) {
      return null;
    }

    return banner.map((values, index) => {
      const icon = <img src={require('../../../Quote/img/warning.svg')} alt={''}/>
      return (
        <div key={index} style={{ margin: '10px 0' }}>
          <CardExpiredBanner
            updatePaymentMethod={this.handleUpdatePaymentMethod}
            icon={icon}
            customerName={values.customerName}
            policyNumber={values.policyNumber}
            policyId={values.policyId}
            travellers={values.travellers}
            tripType={values.tripType}
            expiredPaymentId={values.expiredPaymentId}
            cardStatus={values.cardStatus}
            hasRenewal={values.hasRenewal}
          />
        </div>
      )
    })
  }

  private handleUpdatePaymentMethod = (policyId, expiredPaymentId, travellers, policyNumber) => {
    this.setState({
      policyId,
      expiredPaymentId,
      travellers,
      policyNumber,
      showModal: true,
    })
  }

  private updateCloseModal = () => {
    this.setState({ showModal: false });
  }

  private renderUpdateExpiredCard = () => {
    const { policyId, expiredPaymentId, travellers, policyNumber, showModal } = this.state;
    const { auth, actions } = this.props;
    const customerId = get(auth, 'customer.id');
    return (
      <UpdateExpiredCard
        policyId={policyId}
        expiredPaymentId={expiredPaymentId}
        travellers={travellers}
        customerId={customerId}
        actions={actions.paymentMethod}
        cardUpdated={this.handleCardUpdated}
        policyNumber={policyNumber}
        showModal={showModal}
        updateCloseModal={this.updateCloseModal}
      />
    )
  }

  private handleCardUpdated = () => {
    const { actions } = this.props;
    this.setState({ loading: true })
    Promise.resolve(actions.auth.reloadCustomer()).then(() => {
      this.setState({ loading: false })
    });
  }

  public render() {
    const { loading } = this.state;

    if (loading) {
      return (
        <Loading/>
      )
    }

    return (
      <div className="page-container">
        {this.renderCardExpiryBanner()}
        {this.renderActivePoliciesCard()}
        {this.renderExpiredPoliciesCard()}
        {this.renderOptInRenewalModal()}
        {this.renderUpdateExpiredCard()}
      </div>
    );
  }
}

export default flow([
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());
      promises.push(props.actions.auth.getCustomerRateableClaims());
      promises.push(props.actions.auth.getCustomerUpsellMarketing());
      promises.push(props.actions.branding.loadChannel('admiral-b2c'));

      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        auth: bindActionCreators({ ...authActions }, dispatch),
        header: bindActionCreators({ ...headerActions }, dispatch),
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
        modal: bindActionCreators({ ...modalActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      }
    }),
  ),
])(AccountSummary);
